import _defineProperty from "D:/xampp/htdocs/SNS_Thai/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _en;
var en = (_en = {
  ChooseYourInterest: 'Choose your interest',
  Hot: 'Hot',
  Community: 'Community',
  Activity: 'Activity',
  Video: 'Video',
  News: 'News',
  QA: 'Q&A',
  Knowledge: 'Tips',
  Save: 'Save',
  Comments: 'Comments',
  LatestComments: 'Latest Comments',
  SaySomething: 'Say something...',
  ssthing: 'Say something',
  rely: 'reply',
  seeMore: 'See more',
  Follow: 'Follow',
  followers: 'Followers',
  AllComments: 'All Comments',
  Favorites: 'Favorites',
  Translate: 'Translate',
  Location: 'Location',
  NotDisplayed: 'Not Displayed',
  Signingup: 'Signing up',
  Join: 'Join',
  Ended: 'Ended',
  Times: '6920 Times',
  Pstswy: 'Post something to share with you',
  AddTopic: 'Add Topic',
  Post: 'Post',
  Posts: 'Posts',
  Back: 'Back',
  Last: 'Last',
  Next: 'Next',
  MultiSelect: 'Multi-select',
  MultiChoice: 'Multiple Choice',
  SingleSelect: 'Single Select',
  Singlechoice: 'Single Choice',
  Completion: 'Completion',
  Confirm: 'Confirm',
  Questionnaire: 'Questionnaire',
  Success: 'Success',
  YQHBS: ' Your questionnaire has been submitted.',
  TYFYP: 'Thank you for your participation!',
  PostedSuccessfully: 'Posted Successfully',
  Search: 'Search',
  Communitys: 'Community',
  ChooseTopics: 'Choose topics',
  HotTopic: ' Hot Topic',
  EnterTopic: 'Enter Topic',
  sixHoursago: '6 hours ago',
  RecentSearches: 'Recent Searches',
  HotSearches: 'Hot Searches',
  HotTopics: 'Hot Topics',
  AllTopics: 'All Topics',
  ninePosts: ' 910 Posts',
  QuickEntry: 'Quick Entry',
  NoMoreContents: 'No more contents',
  Unfollow: 'Unfollow',
  following: 'Following',
  lasted: 'Lasted',
  TDSQ: 'Test Drive Service Satisfaction Questionnaire',
  Pasqtiyeeb: 'Please answer some questions to improve your experience even better.',
  CreateATopic: 'Create a topic'
}, _defineProperty(_en, "ChooseTopics", 'Choose Topics'), _defineProperty(_en, "User", 'User'), _defineProperty(_en, "InfotainmentUserManual", 'Infotainment User Manual'), _defineProperty(_en, "OwnerManual", 'Owner Manual'), _defineProperty(_en, "ServiceManual", '这是给经销商的维修手册'), _defineProperty(_en, "EmergencyManual", 'Emergency Manual'), _defineProperty(_en, "userManual", 'User Manual'), _defineProperty(_en, "send", 'Send'), _defineProperty(_en, "join", 'Join'), _defineProperty(_en, "Latest", 'Latest'), _defineProperty(_en, "Following", 'Following'), _defineProperty(_en, "TestDrive", 'Test drive'), _defineProperty(_en, "MultiSelect", 'Multi-Select'), _defineProperty(_en, "quickAccess", 'Quick Access'), _defineProperty(_en, "signUp", 'Signing up'), _defineProperty(_en, "All", 'All'), _defineProperty(_en, "Brochure", 'Brochure'), _defineProperty(_en, "NoData", 'No Data'), _defineProperty(_en, "joined", 'Joined'), _defineProperty(_en, "NoComments", 'No Comments'), _defineProperty(_en, "image", 'Photo'), _defineProperty(_en, "incompleteInformation", 'Incomplete information'), _defineProperty(_en, "Questions", 'Questions'), _defineProperty(_en, "OSUOOV", '*Only 1 video per post'), _defineProperty(_en, "LoadingTxt", 'Loading...'), _defineProperty(_en, "LoosingTxt", 'Release to refresh'), _defineProperty(_en, "pullingTxt", 'Pull to refresh'), _defineProperty(_en, "delete", 'Delete'), _defineProperty(_en, "cancel", 'Cancel'), _defineProperty(_en, "uploading", 'uploading...'), _defineProperty(_en, "signJoin", 'Signed up successfully'), _defineProperty(_en, "cancelJoin", 'Cancelled successfully'), _defineProperty(_en, "ToBeStarted", 'To Be Started'), _defineProperty(_en, "start", 'Start'), _defineProperty(_en, "confirm", 'Confirm'), _defineProperty(_en, "delPost", 'Delete the post'), _defineProperty(_en, "tae", 'The topic already in the system'), _defineProperty(_en, "iinfo", 'Incomplete information'), _defineProperty(_en, "submit", 'Submit'), _defineProperty(_en, "failed", 'failed'), _defineProperty(_en, "friend", 'Friends'), _defineProperty(_en, "pctdtp", 'Please confirm to delete the post？'), _defineProperty(_en, "pctdtc", 'Please confirm to delete the comment？'), _defineProperty(_en, "limitVideo", 'Please upload a video less than 20M'), _defineProperty(_en, "limitShare", 'Loading information, please try again later.'), _defineProperty(_en, "postlater", 'Posting too fast, please try again later'), _defineProperty(_en, "Submitted", 'Submitted'), _defineProperty(_en, "checkTheDetails", 'Check The Details'), _defineProperty(_en, "oversizePicture", 'Please upload a picture less than 10M'), _defineProperty(_en, "oversizeVideo", 'Please upload a video less than 250M'), _defineProperty(_en, "Sorry_No_network", 'Sorry! No network'), _defineProperty(_en, "Refresh", 'Refresh'), _defineProperty(_en, "MaxPioture", 'Only 9 images per post,the most recently selected 9 images are being uploaded'), _defineProperty(_en, "Camera", 'Camera'), _defineProperty(_en, "File", 'File'), _defineProperty(_en, "Picture", 'Picture'), _defineProperty(_en, "Cancel", 'Cancel'), _defineProperty(_en, "TimeOut", 'Timed out, please try again.'), _defineProperty(_en, "UploadFailed", 'Upload failed'), _en);
export default en;